export default __webpack_public_path__ + "media/images/logo-c95f1650e8cb51326ad7308e72f52d5a.svg";